import { EVehicleType, UUID, UUID_NULL } from '@okcargo-apps/shared-domain';

export interface IAccountPreferences {
  id: UUID;

  consentEmail: boolean;
  consentWhatsApp: boolean;
  consentPhone: boolean;
  contactEmail?: string;
  contactPhone?: string;
  contactWhatsApp?: string;
  // vehicleTypes?: EVehicleType[];
  routes?: IPreferenceRoutes[];
  emailPeriodicity?: EMailingPeriodicity;
  freightsPerWeek?: number;

  // freightsPerWeek: number;

  tractorNumber?: number;
  canvasNumber?: number;
  boxNumber?: number;
  frigoNumber?: number;
  megaNumber?: number;

  // TODO Keep only for compatibility with the old questionnaire. In the future, remove
  oldQuestionnaire?: IOldQuestionnaire;
}

export interface IPreferenceRoutes {
  id: UUID;
  vehicleType: EVehicleType;
  originCountryIsoCode: string;
  originStateCode?: string;
  destinationCountryIsoCode: string;
  destinationStateCode?: string;
  originStateName?: string;
  destinationStateName?: string;
}

export interface IRouteGroup {
  id: string;
  origin: string;
  vehicleType: EVehicleType;
  destinations: IPreferenceRoutes[];
}

// TODO Keep only for compatibility with the old questionnaire. In the future, remove
export interface IOldQuestionnaire {
  carrierOrAgency?: boolean;
  interestedOnSameLines?: boolean;
  firstContact?: string;
  futureContact?: string[];
  isUsefullAcceptFreightWithLink?: boolean;
  receiveAllFreights?: boolean;
  exclusiveCarrier?: boolean;
  numberOfVehicles?: number;
  vehicleTypes?: string[];
  whatsappCommunicationsPhone?: string;
  comments?: string;
}

export function getEmptyIAccountPreferences(): IAccountPreferences {
  return {
    id: UUID_NULL,
    consentEmail: false,
    consentWhatsApp: false,
    consentPhone: false,
  };
}

export enum EMailingPeriodicity {
  REALTIME = 'REALTIME',
  HALF_HOURLY = 'HALF_HOURLY',
  HOURLY = 'HOURLY',
  TWICE_A_DAY = 'TWICE_A_DAY',
  MID_WORKING_HOUR = 'MID_WORKING_HOUR',
  LAST_WORKING_HOUR = 'LAST_WORKING_HOUR',
  NEVER = 'NEVER',
}
